var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8"},[_vm._l((3),function(f){return _c('v-skeleton-loader',{staticStyle:{"opacity":"0.4"},attrs:{"width":"100%","type":"list-item-avatar-two-line","boilerplate":false}})}),_c('v-skeleton-loader',{staticClass:"mt-10",staticStyle:{"opacity":"0.4"},attrs:{"width":"100%","type":"list-item","boilerplate":false}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }